import Svg, { Defs, G, Path, RadialGradient, Rect, Stop } from 'react-native-svg';
import { useId } from 'react';
import { withDefaultIconProps } from './index';

export const AmbassadorMedal = withDefaultIconProps(
  {
    height: 74,
    width: 60,
  },
  ({ color: _color, style, ...rest }) => {
    const id = useId();
    const gradientId = `${id}-paint0_radial`;
    return (
      <Svg {...rest} viewBox="0 0 57 60" style={style}>
        <G>
          <G>
            <Path
              d="M18.08 30.32h23.46v25.01c0 1.42-1.64 2.2-2.74 1.3l-7.93-6.52a1.67 1.67 0 00-2.12 0l-7.93 6.52c-1.09.9-2.74.12-2.74-1.3v-25.01z"
              fill={`url(#${gradientId})`}
            />
          </G>
          <Path
            opacity={0.13}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.08 43.77V32.2h23.46V43.77a19.95 19.95 0 01-11.73 3.79c-4.38 0-8.43-1.41-11.73-3.79z"
            fill="#315B4A"
          />
          <Rect transform="translate(10.69 3.98)" width={38.2535} height={38.2535} rx={19.1268} fill="#2B8176" />
          <Rect
            transform="translate(10.69 3.98)"
            width={38.2535}
            height={38.2535}
            rx={19.1268}
            fill="none"
            stroke="#fff"
            strokeWidth={1.1831}
          />
          <Path
            d="M23.72 18.73a9.43 9.43 0 00-.48 2.99c0 4.4 2.94 7.97 6.57 7.97m0 0c3.63 0 6.57-3.57 6.57-7.97a9.42 9.42 0 00-.48-2.99m-6.09 10.96c1.99 0 2.74 3.29 2.74 3.29m-2.74-3.29c-1.99 0-2.74 3.29-2.74 3.29m9.88-17.27c.32 1.82-1.12 3.03-1.12 3.03s-1.76-.62-2.08-2.44c-.32-1.82 1.12-3.03 1.12-3.03s1.76.62 2.08 2.44z"
            fill="none"
            stroke="#B4ECDF"
            strokeWidth={1.84859}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <Path
            d="M22.99 29.89c1.64-.63 1.9-2.4 1.9-2.4s-1.39-1.14-3.03-.51c-1.64.63-1.9 2.4-1.9 2.4s1.39 1.14 3.03.51m16.79-6.63c-1.4 1.39-3.3.83-3.3.83s-.5-1.94.91-3.33c1.4-1.39 3.3-.83 3.3-.83s.5 1.94-.91 3.33zm-3.13 6.63c-1.64-.63-1.9-2.4-1.9-2.4s1.39-1.14 3.03-.51c1.64.63 1.9 2.4 1.9 2.4s-1.39 1.14-3.03.51zm-16.79-6.63c1.4 1.39 3.3.83 3.3.83s.5-1.94-.91-3.33c-1.4-1.39-3.3-.83-3.3-.83s-.5 1.94.91 3.33zm2.82-7.57c-.32 1.83 1.12 3.04 1.12 3.04s1.76-.62 2.08-2.44c.32-1.82-1.12-3.03-1.12-3.03s-1.76.62-2.08 2.44z"
            fill="none"
            stroke="#B4ECDF"
            strokeWidth={1.84859}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </G>
        <Defs>
          <RadialGradient
            id={gradientId}
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(-1.12475 13.7978 -20.2057 -1.66535 30.71 36.04)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#2B8176" />
            <Stop offset={1} stopColor="#B4ECDF" />
          </RadialGradient>
        </Defs>
      </Svg>
    );
  },
);
